import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMailbox: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconMailbox"><Path d="M17.5 4C19.9853 4 22 6.01472 22 8.5V20H15V22H13V8.5C13 6.75302 12.3098 5.16799 11.1885 4H17.5Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M6.5 4C8.98528 4 11 6.01472 11 8.5V20H2V8.5C2 6.01472 4.01472 4 6.5 4ZM4.5 9V11H8.5V9H4.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMailbox;
